<div class="filters">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchValue" (ngModelChange)="queueFilter($event)">
    <mat-hint>Search log ID, user ID/name/email, vendor product ID, vendor slug, method, status, or vendor/product name.</mat-hint>
    @if (searchValue) {
      <button mat-icon-button matSuffix aria-label="Clear search" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
</div>

<div #scrollContainer class="scroll-container" (scroll)="onScroll($event)">
  <table mat-table [dataSource]="items" class="table">
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef>Created</th>
      <td mat-cell *matCellDef="let item">{{item.createdAt | date:'medium'}}</td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef>User</th>
      <td mat-cell *matCellDef="let item" class="user-cell">{{getUserDisplay(item)}}</td>
    </ng-container>

    <ng-container matColumnDef="vendorName">
      <th mat-header-cell *matHeaderCellDef>Vendor</th>
      <td mat-cell *matCellDef="let item">{{item.vendorName || getVendor(item)}}</td>
    </ng-container>

    <ng-container matColumnDef="productName">
      <th mat-header-cell *matHeaderCellDef>Product</th>
      <td mat-cell *matCellDef="let item">{{item.productName || getProduct(item)}}</td>
    </ng-container>

    <ng-container matColumnDef="method">
      <th mat-header-cell *matHeaderCellDef>Method</th>
      <td mat-cell *matCellDef="let item">{{getMethod(item)}}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>HTTP Status</th>
      <td mat-cell *matCellDef="let item">{{getStatus(item)}}</td>
    </ng-container>

    <ng-container matColumnDef="outcome">
      <th mat-header-cell *matHeaderCellDef>Outcome</th>
      <td mat-cell *matCellDef="let item">{{getOutcome(item)}}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item" class="actions-cell">
        <button mat-icon-button [matMenuTriggerFor]="actionsMenu" [matMenuTriggerData]="{item: item}" (click)="$event.stopPropagation()">
          <mat-icon>more_vert</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  @if (loading) {
    <div class="loading">Loading...</div>
  }
  @if (!loading && loadError) {
    <div class="error">
      {{loadErrorMessage}}
      <button mat-button type="button" (click)="retryLoad()">Retry</button>
    </div>
  }
  @if (!loading && !loadError && items.length === 0) {
    <div class="empty">There are no vendor API log entries to show.</div>
  }
</div>

<mat-menu #actionsMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    <button mat-menu-item (click)="$event.stopPropagation(); openDetails(item)">View Details</button>
  </ng-template>
</mat-menu>
